var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgProgressDone = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66797,
    y: 1,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#255E8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7833 5.6364C11.6798 5.54271 11.5435 5.49388 11.4041 5.50061C11.2647 5.50735 11.1337 5.5691 11.0398 5.67233L7.82911 9.20794L6.27791 7.63094C6.17946 7.53426 6.04698 7.48012 5.90899 7.48016C5.771 7.48021 5.63856 7.53444 5.54016 7.63117C5.44176 7.72791 5.38528 7.85942 5.38289 7.99738C5.3805 8.13535 5.43239 8.26873 5.52738 8.36882L7.46927 10.3426C7.5182 10.3924 7.57656 10.432 7.64095 10.459C7.70534 10.4861 7.77446 10.5 7.84429 10.5H7.85441C7.92609 10.4986 7.99673 10.4825 8.062 10.4529C8.12727 10.4232 8.18579 10.3805 8.23399 10.3274L11.8192 6.37986C11.9129 6.27645 11.9617 6.14008 11.955 6.0007C11.9482 5.86131 11.8865 5.7303 11.7833 5.6364Z",
    fill: "white",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.66797,
    y: 1,
    width: 14,
    height: 14,
    rx: 7,
    stroke: "#255E8E",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgProgressDone, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/progress-done.332f1f49.svg";
export { ForwardRef as ReactComponent };